export function isAllowedAnonymousLocation(location: string): boolean {
  try {
    const pathname = new URL(location).pathname;
    switch (pathname) {
      case '/no-access':
      case '/signout-oidc':
        return true;

      default:
        return false;
    }
  } catch (error) {
    return false;
  }
}
